import React from "react";

const SelectedVoiceImage = ({ selectedVoice }) => {
  return (
    <div className="flex flex-col justify-center items-center w-1/4 md:w-1/5 lg:w-1/12 min-w-[100px]">
      <img src={selectedVoice?.image} alt="" className="h-20 md:h-32 object-cover" />
      <span className="text-md md:text-lg">{selectedVoice?.name}</span>
    </div>
  );
};

export default SelectedVoiceImage;
